import { useCallback, useEffect, useState } from 'react'

import history from '../../../routes/history'
import {
  areCatalogFiltersEqual,
  buildCatalogSearch,
  DEFAULT_SORT_DIRECTIONS,
  parseCatalogFilters,
} from '../utils/catalog-filters'

const SLOTS_PATH = '/slots'

export const useCatalogFilters = () => {
  const [filters, setFilters] = useState(() =>
    parseCatalogFilters(history.location.search)
  )

  useEffect(() => {
    const nextSearch = buildCatalogSearch(filters, history.location.search)
    const currentSearch = history.location.search || ''

    if (currentSearch !== nextSearch) {
      history.replace({
        pathname: SLOTS_PATH,
        search: nextSearch,
      })
    }
  }, [filters])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== SLOTS_PATH) {
        return
      }

      const nextFilters = parseCatalogFilters(location.search)

      setFilters((prev) =>
        areCatalogFiltersEqual(prev, nextFilters) ? prev : nextFilters
      )
    })

    return unlisten
  }, [])

  const setSelectedType = useCallback((type) => {
    setFilters((prev) => ({
      ...prev,
      selectedType: type?.game_type || type || 'all',
    }))
  }, [])

  const setSearchText = useCallback((searchText) => {
    setFilters((prev) => ({
      ...prev,
      searchText,
    }))
  }, [])

  const handleSort = useCallback((value) => {
    setFilters((prev) => {
      if (prev.sortBy === value) {
        return {
          ...prev,
          sortDirection: prev.sortDirection * -1,
        }
      }

      return {
        ...prev,
        sortBy: value,
        sortDirection: DEFAULT_SORT_DIRECTIONS[value] ?? 1,
      }
    })
  }, [])

  return {
    selectedType: filters.selectedType,
    searchText: filters.searchText,
    sortBy: filters.sortBy,
    sortDirection: filters.sortDirection,
    setSelectedType,
    setSearchText,
    handleSort,
  }
}
